import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PatientService } from '../service/patient-service.service';
import { VitalSignService } from '../service/vital-sign.service';
import { AppointmentService } from '../../../section/appointment/service/appointment.service';
import { MasterOperationService } from '../../master/services/master-operation.service';
import { MedicalHistoryService } from '../../master/services/medical-history.service';
import { PatientRouteModule } from '../patient-route/patient-route.module';
import { ClinicalNotesService } from '../service/clinical-notes.service';
import { DiagnoseService } from '../../master/services/diagnose.service';
import { InvestigationService } from '../../master/services/investigation.service';
import { ObservationService } from '../../master/services/observation.service';
import { ComplaintService } from '../../master/services/complaint.service';
import { NoteService } from '../../master/services/note.service';
import { DrugServiceService } from '../../master/services/drug-service.service';
import { PrescriptionService } from '../service/prescription.service';
@NgModule({
   imports: [
    CommonModule,
    PatientRouteModule
  ],
  declarations: [],
  providers : [
    MasterOperationService,PatientService, MedicalHistoryService, AppointmentService,
    VitalSignService, ClinicalNotesService, DiagnoseService, InvestigationService, ObservationService,
    ComplaintService, NoteService,DrugServiceService,PrescriptionService
  ]
})
export class PatientModule { }



// WEBPACK FOOTER //
// ./src/app/section/patient/patient-module/patient.module.ts